import React, { Component } from "react";

class HexagonIcon extends Component {
  static defaultProps = {
    fillHex: "transparent",
    strokeHex: "#000000",
    strokeWidthHex: 2,
  };

  render() {
    const { fillHex, strokeHex, strokeWidthHex } = this.props;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 40 40"
        className="answer--btn-icon"
        style={{
          shapeRendering: "geometricPrecision",
          textRendering: "geometricPrecision",
          imageRendering: "optimizeQuality",
          fillRule: "evenodd",
          clipRule: "evenodd",
        }}
      >
        {/* Hexagon */}
        <path
          d="M 10 2 L 30 2 L 38 20 L 30 38 L 10 38 L 2 20 Z"
          fill={fillHex}
          stroke={strokeHex}
          strokeWidth={strokeWidthHex}
          strokeLinejoin="round"
          className="hexagon"
        />

        {/* Trojúhelník uprostřed sahající do vrcholů hexagonu */}
        <path
          d="M 10 3 L 10 37 L 37 20 Z"
          fill="none"
          stroke={strokeHex}
          strokeWidth={strokeWidthHex}
          className="triangle"
        />
      </svg>
    );
  }
}

export default HexagonIcon;
